<template>
  <div class="detail-layout-container">
    <div class="detail-layout">
      <DefaultPanel :is-collapsible="false">
        <template #header>
          <slot name="panel-header" />
        </template>
        <template #header-controls>
          <slot name="panel-header-controls" />
        </template>
        <slot name="panel-content" />
      </DefaultPanel>
      <div class="sidebar-column">
        <AnnotationList
          v-if="dv.isAnnotatable"
          :id="dv.recordId"
          :app-name="dv.appName"
          :model-name="dv.modelName"
          :can-edit="dv.canEdit"
          :is-editing="dv.isEditing"
          :load-from="loadAnnotationsFrom"
          @delete="(id) => dv.removeField(id)"
        />
        <slot name="sidebar-before-attachments" />
        <AttachmentFilesList
          v-if="dv.isAttachmentable"
          :files="dv.attachments"
          :allow-upload="true"
          :can-edit="dv.canEdit"
          :is-editing="dv.isEditing"
        />
        <LineageGraphPanel v-if="showLineage" :uuid="dv.recordId" />
        <OrderList
          v-if="dv.isOrderable && dv.modelName !== 'ordereditems'"
          :app-name="dv.appName"
          :stock-id="dv.recordId"
        />
        <NoteList
          v-if="dv.isNoteable"
          :can-add-note="true"
          :editable="true"
          :app-name="dv.appName"
          :model-name="dv.modelName"
          :model-type="dv.modelType"
        />
        <slot name="sidebar-extra" />
      </div>
    </div>
  </div>
  <div v-if="$slots['extra-panels']" class="extra-panels">
    <slot name="extra-panels" />
  </div>
</template>

<script>
import AnnotationList from '@/components/AnnotationList.vue'
import AttachmentFilesList from '@/components/AttachmentFilesList.vue'
import DefaultPanel from '@/components/DefaultPanel.vue'
import LineageGraphPanel from '@/components/LineageGraphPanel.vue'
import NoteList from '@/components/NoteList.vue'
import OrderList from '@/components/OrderList.vue'

export default {
  name: 'DetailViewLayout',
  components: {
    AnnotationList,
    AttachmentFilesList,
    DefaultPanel,
    LineageGraphPanel,
    NoteList,
    OrderList,
  },
  props: {
    dv: { type: Object, required: true },
    // Layout options
    showLineage: { type: Boolean, default: false },
    loadAnnotationsFrom: { type: Object, default: null },
  },
}
</script>

<style lang="scss" scoped>
.detail-layout-container {
  container-type: inline-size;
}

.detail-layout {
  display: grid;
  align-items: start;
  gap: var(--space-4);
  @include cq(page-main, $cq-page-wide) {
    grid-template-columns: 55% 1fr;
    &:has(.sidebar-column:empty) {
      grid-template-columns: 1fr;
    }
  }
}

.sidebar-column {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  min-width: 0;
  &:empty {
    display: none;
  }
}

.extra-panels {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  margin-top: var(--space-2);
}
</style>
